import { Clock, RefreshCw, FlaskConical } from "lucide-react";
import { fmtDate, timeAgo } from "../../lib/trace";

const DOT = { ok: "bg-trace-green", error: "bg-red-500", demo: "bg-amber-400" };
const NAMES = { solana_rpc: "Solana RPC", dexscreener: "DexScreener", rugcheck: "RugCheck" };

export const DemoBanner = () => (
  <div role="alert" data-testid="demo-data-banner"
    className="demo-stripes flex flex-wrap items-center gap-3 rounded-xl border border-amber-500/50 bg-amber-500/5 px-5 py-4 text-sm text-amber-100">
    <FlaskConical size={18} className="text-amber-400" />
    <strong className="font-mono uppercase tracking-wider text-amber-300">Demo data</strong>
    <span>Every value on this page is a placeholder for illustration. It is not live blockchain data and describes no real token.</span>
  </div>
);

export const ScanStatusBar = ({ data, onRefresh, refreshing }) => (
  <div className="flex flex-col gap-4 rounded-xl border border-trace-line bg-trace-panel px-5 py-4 lg:flex-row lg:items-center lg:justify-between" data-testid="scan-status-bar">
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm">
      <Clock size={15} className="text-trace-green" aria-hidden="true" />
      <span className="text-trace-muted">{data.is_demo ? "Demo generated" : "Last updated"}</span>
      <time dateTime={data.fetched_at} data-testid="last-updated-timestamp" className="font-mono text-white">{fmtDate(data.fetched_at)}</time>
      <span className="text-trace-dim">({data.is_demo ? "placeholder, not retrieved from chain" : `${timeAgo(data.fetched_at)}${data.cache_age_seconds > 0 ? " · cached" : ""}`})</span>
    </div>
    <div className="flex flex-wrap items-center gap-2">
      {Object.entries(data.sources).map(([k, s]) => (
        <span key={k} title={s.detail} data-testid={`source-status-${k}`}
          className="inline-flex items-center gap-1.5 rounded-full border border-trace-line bg-trace-card px-2.5 py-1 font-mono text-[11px] text-trace-muted">
          <span className={`h-1.5 w-1.5 rounded-full ${DOT[s.status] || "bg-slate-500"}`} />
          {NAMES[k]}{s.status === "error" ? " · unavailable" : s.status === "demo" ? " · demo" : ""}
        </span>
      ))}
      {!data.is_demo && (
        <button onClick={onRefresh} disabled={refreshing} data-testid="refresh-scan-button"
          className="ml-1 inline-flex items-center gap-1.5 rounded-full border border-trace-green/40 px-3 py-1 text-xs text-trace-green transition-colors hover:bg-trace-green/10 disabled:opacity-50">
          <RefreshCw size={12} className={refreshing ? "animate-spin" : ""} /> {refreshing ? "Refreshing" : "Refresh"}
        </button>
      )}
    </div>
  </div>
);
